import React, { useState } from "react"

import { useUsers, userTypes, targetTypes } from "../../../../hooks/api/useUsers"

import {
    customInjectionProps as _customerInjectionProps,
    customInjectionFields as _customerInjectionFields,
    initialValues as _initialValues,
    initialRowValues as _initialRowValues,
    initialPasswordValues as _initialPasswordValues,
    validationSchema as _validationSchema,
    validationPasswordSchema as _validationPasswordSchema,
} from '../../schema/user/customerSchema';

// import {
//     useInjectionProps,
//     propTypes as injectionPropTypes,
//     propRefs as injectionPropRefs,
//     propFieldTypes as injectionPropFieldTypes,
//     targetTypes as injectionPropTargetTypes,
// } from "../../../../hooks/api/useInjectionProps"

import {
    useInjectionFields,
    scopeTypes as injectionFieldScopeTypes,
} from "../../../../hooks/api/useInjectionFields"

import { getInjectionDataType } from "../../utils/injectionSelection";

export const customerInjectionProps = _customerInjectionProps
export const customerInjectionFields = _customerInjectionFields
export const initialValues = _initialValues
export const initialRowValues = _initialRowValues
export const initialPasswordValues = _initialPasswordValues
export const validationSchema = _validationSchema
export const validationPasswordSchema = _validationPasswordSchema

export function useCustomer({
    jwtToken: _jwtToken,
    routeType: _routeType
}) {

    const [routeType, setRouteType] = useState(_routeType)

    const { isLoading, get, list, create, update, filterOperatorTypes } = useUsers({ userType: userTypes.customer, targetType: targetTypes.customer });

    // const { create: createInjectionProps } = useInjectionProps({
    //     propType: injectionPropTypes.user.customer.id,
    //     targetType: injectionPropTargetTypes.user.id,
    // });

    const { getUpdateFieldValuesPayload, updateFieldValues } = useInjectionFields({
        scopeType: injectionFieldScopeTypes.user.id
    });

    // private
    const validateInputMarkings = async ({ markings, customerUserId }) => {

        // console.log('markings', markings)

        let allResponses = await Promise.all(markings.map(async (marking) => {
            // const res = await fetchCustomers({ marking })

            const props = {
                limit: 5,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: 0,
                },
                filterValue: [
                    {
                        name: customerInjectionProps.marking.retrieveKey,
                        operator: filterOperatorTypes.havingInOr,
                        value: JSON.stringify([marking])
                    }
                ],
            }

            // const { data } = await listUsers(props)
            const data = await listCustomers({
                props
            })

            // const res = await listCustomers({ marking })
            return data
        }));

        // console.log('allResponses', allResponses)

        let validateResults = []

        // check all markings response
        allResponses.forEach((response, index) => {

            let isTaken = false
            let isTakenBy = ""
            let marking = markings[index]

            response.forEach(i => {
                if (i?.user_id !== customerUserId) {
                    isTaken = true
                    isTakenBy = i?.user_id
                }
            })

            validateResults.push({
                marking,
                isTaken,
                isTakenBy
            })

        })

        // console.log('vali', validateResults)

        return validateResults
    }

    // list customers
    const listCustomers = async ({
        props,
        // status: _status,
        // markingIds: _markingIds = [],
        // markingKeyword: _markingKeyword = '',
        dataTypes: _dataTypes = [`${getInjectionDataType('customer')}`]
    }) => {

        props.dataTypes = _dataTypes
        // props.configuration = {
        //     [_configuration.enableServerClientCancellation.id]: true
        // }

        let filterValues = [
        ]

        // if (_status !== '') {
        //     filterValues = [...filterValues, ...[
        //         {
        //             name: `status`,
        //             operator: filterOperatorTypes.eq,
        //             value: _status
        //         }
        //     ]]
        // }

        // if (_markingKeyword !== '') {
        //     filterValues = [...filterValues, ...[
        //         {
        //             name: `${markingInjectionProps.marking.retrieveKey}`,
        //             operator: filterOperatorTypes.contains,
        //             value: _markingKeyword
        //         }
        //     ]]
        // }

        // if (_markingIds.length > 0) {
        //     filterValues = [...filterValues, ...[
        //         {
        //             name: `id`,
        //             operator: filterOperatorTypes.anyOf,
        //             value: JSON.stringify(_markingIds)
        //         }
        //     ]]
        // }

        if (props?.filterValue) {
            props.filterValue = [...props.filterValue, ...filterValues]
        } else {
            props.filterValue = filterValues
        }

        const result = await list(props)

        let data = result?.data?.customers ? result.data.customers : []

        return {
            data,
            // count: result?.data?.nofilter_total
            count: result?.data?.total
        }

    }

    // get customer
    const getCustomer = async ({
        id,
        dataTypesArray = ["customer_injection_props_array"]
    }) => {

        const result = await get({ id, dataTypesArray })

        let data = result?.data ? result.data : {}

        return data

    }

    // done
    // add customer
    const addCustomer = async ({
        inputMarkings: _inputMarkings = [],
        credential: _credential = {
            username: '',
            password: '',
            firstname: '',
            lastname: '',
            contact: '',
            email: '',
            status: 1,
        },
        customer: _customer = {
            regNo: '',
            companyName: '',
            code: '',
            accountCode: '',
            remark: '',
        },
        props: _props = {
            salesperson: '',
        },
    }) => {

        let data = {
            credential: {
                username: _credential?.username,
                password: _credential?.password,
                firstname: _credential?.firstname,
                lastname: _credential?.lastname,
                contact: _credential?.contact,
                email: _credential?.email,
                status: _credential?.status ? 1 : 0,
            },
            customer: {
                reg_no: _customer?.regNo,
                company_name: _customer?.companyName,
                code: _customer?.code,
                account_code: _customer?.accountCode,
                remark: _customer?.remark,
            },
            props: {
                salesperson: _props?.salesperson,
            },
        };

        let response = await create({ data });

        const { user } = response?.data ? response.data : {};

        // insert injection props
        // let injectionProps = [
        //     {
        //         props_module: injectionPropTypes.user.customer.id,
        //         props_ref: injectionPropTargetTypes.user.id,
        //         ref_id: {
        //             [injectionPropRefs.user.customer]: user?.id,
        //         },
        //         props_key: customerInjectionProps.marking.submitKey,
        //         props_field: customerInjectionProps.marking.propFieldId,
        //         [customerInjectionProps.marking.propFieldName]: JSON.stringify(_inputMarkings),
        //         is_multiple: customerInjectionProps.marking.propIsMultiple,
        //     },
        // ];

        // let dataInjectionProps = {
        //     injection_props: injectionProps,
        // };

        // const responseInjectionProps = await createInjectionProps({ data: dataInjectionProps });

        // insert injection fields
        let dataInjectionFields = getUpdateFieldValuesPayload({
            items: [
                {
                    key: `${customerInjectionFields.marking.submitKey}`,
                    ref: `${customerInjectionFields.marking.ref}`,
                    module: `${customerInjectionFields.marking.module}`,
                    refId: `${user?.id}`,
                    value: `${JSON.stringify(_inputMarkings)}`
                }
            ]
        })

        console.log('dataInjectionFields', dataInjectionFields)

        const responseInjectionFields = await updateFieldValues({ data: dataInjectionFields });

        return response

    }

    // done
    const updateCustomer = async ({
        customerUserId: _customerUserId = '',
        inputMarkings: _inputMarkings = [],
        credential: _credential = {
            firstname: '',
            lastname: '',
            password: '',
            contact: '',
            email: '',
            status: '',
        },
        customer: _customer = {
            regNo: '',
            companyName: '',
            code: '',
            accountCode: '',
            remark: '',
        },
        // props: _props = {
        //     salesperson: "",
        //     marking: []
        // },
    }) => {

        let data = {
            credential: {
                firstname: _credential?.firstname,
                lastname: _credential?.lastname,
                password: _credential?.password,
                contact: _credential?.contact,
                email: _credential?.email,
                status: _credential?.status ? 1 : 0,
            },
            customer: {
                reg_no: _customer?.regNo,
                company_name: _customer?.companyName,
                code: _customer?.code,
                account_code: _customer?.accountCode,
                remark: _customer?.remark
            },
            props: {
                salesperson: "",
                marking: []
            },
            custom_fields: [],

        }
        const response = await update({ id: _customerUserId, data });

        if (response?.status) {

            // check marking are takens with input
            let validateMarkings = await validateInputMarkings({ markings: _inputMarkings, customerUserId: _customerUserId })

            // console.log('validateMarkings', validateMarkings)

            let _totalTaken = validateMarkings.filter(i => i.isTaken === true)
            let checkIsAllValid = (_totalTaken.length === 0)

            if (checkIsAllValid === false) {
                // promptMessage(false, `${_totalTaken.map(i => i.marking).join(", ")} has been taken`)
                throw Error(`${_totalTaken.map(i => i.marking).join(", ")} has been taken`)
                // return false
            }

            // let injectionProps = [
            //     {
            //         props_module: injectionPropTypes.user.customer.id,
            //         props_ref: injectionPropTargetTypes.user.id,
            //         ref_id: {
            //             [injectionPropRefs.user.customer]: _customerUserId
            //         },
            //         props_key: customerInjectionProps.marking.submitKey,
            //         props_field: customerInjectionProps.marking.propFieldId,
            //         [customerInjectionProps.marking.propFieldName]: _inputMarkings,
            //         is_multiple: customerInjectionProps.marking.propIsMultiple
            //     },
            // ];

            // let dataInjectionProps = {
            //     injection_props: injectionProps
            // }

            // const responseInjectionProps = await createInjectionProps({ data: dataInjectionProps })

            // insert injection fields
            let dataInjectionFields = getUpdateFieldValuesPayload({
                items: [
                    {
                        key: `${customerInjectionFields.marking.submitKey}`,
                        ref: `${customerInjectionFields.marking.ref}`,
                        module: `${customerInjectionFields.marking.module}`,
                        refId: `${_customerUserId}`,
                        value: `${JSON.stringify(_inputMarkings)}`
                    }
                ]
            })

            console.log('dataInjectionFields', dataInjectionFields)

            const responseInjectionFields = await updateFieldValues({ data: dataInjectionFields });

        }

        return response
    }

    return {
        isLoading,
        filterOperatorTypes,
        listCustomers,
        getCustomer,
        addCustomer,
        updateCustomer
    }
}